'use client';

import { Toaster as SonnerToaster } from 'sonner';

/** App-wide toast host. Mounted once in the root layout. */
export function Toaster() {
  return (
    <SonnerToaster
      position="top-center"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: 'rounded-lg border border-border',
        },
      }}
    />
  );
}

export { toast } from 'sonner';
